import React from 'react';
import { Loading as Loader } from '@carbon/react';

export default function MainLoader(props) {
  return (
    <div>
      <Loader
        description="Loading..."
        withOverlay={true}
        small={false}
        className="main-loader"
        {...props}
      />
    </div>
  );
}
